module.exports = __webpack_public_path__ + "static/media/haiwaizhoubaomuban.27b449de.png";